import React from 'react'
import DashboardPicker from '../common/DashboardPicker'
import Routes from '../../../common/Routes'

const SwimmingDashboardPicker = (props) => {
  const dashboards = [
    {
      id: 1,
      name: 'components.dashboards.riding.sub_dashboards.single',
      icon: 'swimmer',
      enabled: true,
      abbrevName: 'swimming',
      cssKlass: 'dashboard-card-questionnaire',
      implemented: true,
      link: Routes.analysis.swimming.single.index
    }, {
      id: 2,
      name: 'components.dashboards.riding.sub_dashboards.trends',
      icon: 'calendar-week',
      enabled: true,
      abbrevName: 'swimming',
      cssKlass: 'dashboard-card-questionnaire',
      implemented: true,
      link: Routes.analysis.swimming.trends
    }
  ]

  return (
    <DashboardPicker dashboards={dashboards} {...props} />
  )
}

export default SwimmingDashboardPicker
